import { useNitroPoolsList } from '@app/hooks/nitro/useNitroPoolsList';
import { useMemo } from 'react';
import { HIDDEN_NITRO_POOLS } from '@app/constants/common';

const NOW = new Date().getTime();

export function useNitroPool(
  nftPoolAddress: string | undefined,
  nitroPoolId?: string
) {
  const { data, isLoading } = useNitroPoolsList();

  const pools = useMemo(() => {
    if (!data || !nftPoolAddress) {
      return [];
    }

    // get vault NFT pool
    // find nitro by NFT pool address
    // it must be published, in start /end time range

    if (
      nitroPoolId
      // remove this from filtering until user withdraw from nitro
      // !HIDDEN_NITRO_POOLS.includes(nitroPoolId.toLowerCase())
    ) {
      return data.filter(
        item => item.id.toLowerCase() === nitroPoolId.toLowerCase()
      );
    }

    return data.filter(item => {
      // remove this from filtering until user withdraw from nitro
      if (HIDDEN_NITRO_POOLS.includes(item.id)) {
        return false;
      }

      if (nitroPoolId && item.id !== nitroPoolId) {
        return false;
      }

      if (!item.published) {
        return false;
      }

      if (item.nftPool.toLowerCase() !== nftPoolAddress.toLowerCase()) {
        return false;
      }

      return NOW >= +item.startTime * 1000 && NOW <= +item.endTime * 1000;
    });
  }, [data, nftPoolAddress, nitroPoolId]);

  const p = pools.sort((a, b) => {
    if (+a.startTime < +b.startTime) {
      return 1;
    }

    if (+a.startTime > +b.startTime) {
      return -1;
    }

    return 0;
  });

  // console.log(p);

  return {
    data: p[0],
    isLoading
  };
}
